import { formatDate } from "@/shared/lib/date-time";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@devhop/ui";
import type { RoomUsageTrendItemDTO } from "../api/client";

type RoomUsageTrendTableProps = {
  isLoading: boolean;
  data: RoomUsageTrendItemDTO[];
};

export function RoomUsageTrendTable({
  isLoading,
  data,
}: RoomUsageTrendTableProps) {
  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="w-[140px]">ວັນທີ</TableHead>
            <TableHead className="w-[160px] text-right">ຊົ່ວໂມງທີ່ໃຊ້</TableHead>
            <TableHead className="w-[140px] text-right">
              ຈຳນວນຄັ້ງ
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {isLoading ? (
            <TableRow>
              <TableCell
                colSpan={3}
                className="h-24 text-center text-muted-foreground"
              >
                ກຳລັງໂຫລດ...
              </TableCell>
            </TableRow>
          ) : data.length === 0 ? (
            <TableRow>
              <TableCell
                colSpan={3}
                className="h-24 text-center text-muted-foreground"
              >
                ບໍ່ພົບຂໍ້ມູນໃນຊ່ວງວັນທີ່ເລືອກ
              </TableCell>
            </TableRow>
          ) : (
            data.map((row) => (
              <TableRow key={row.date}>
                <TableCell className="text-muted-foreground text-sm">
                  {formatDate(row.date)}
                </TableCell>
                <TableCell className="text-right tabular-nums">
                  {row.totalHoursUsed.toLocaleString()} ຊົ່ວໂມງ
                </TableCell>
                <TableCell className="text-right tabular-nums">
                  {row.sessionsCount.toLocaleString()}
                </TableCell>
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </div>
  );
}
